import script from "./libraryEcology.vue?vue&type=script&setup=true&lang=js"
export * from "./libraryEcology.vue?vue&type=script&setup=true&lang=js"

import "./libraryEcology.vue?vue&type=style&index=0&id=4a5ae64b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a5ae64b"]])

export default __exports__